import React from 'react';

import Auth0RolesContainer from '@totem/components/administration/auth0/roles/Auth0RolesContainer';
import {
  Auth0RolesExtra,
  Auth0RolesLayout,
} from '@totem/components/administration/auth0/roles/Auth0RolesLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const Auth0RolesPage = () => (
  <ContentLayout>
    <Auth0RolesContainer>
      <IBCard isCovered title="Auth0 Roles" extra={<Auth0RolesExtra />}>
        <Auth0RolesLayout />
      </IBCard>
    </Auth0RolesContainer>
  </ContentLayout>
);

export default Auth0RolesPage;
